/**
 * A simple map built on associative arrays,
 * numeric keys are converted to strings
 * @type {Map}
 */
export class PokerMap<T> {
	private holder
	length : number
    
	constructor() {
		this.holder = new Object()
		this.length = 0
	}
    
	/**
     * Retrieves the number of elements the Map
     * @return {Number}
     */
	size() {
		return this.length
	}
	contains(key) {
		var key = this._key(key)
		return this.get(key)!=null
	}
	/**
     *
     * @param key
     * @return {*}
     * @private
     */
	_key(key) {
		if (key===undefined) {
			console.warn('Key was undefined ', new Error())
			throw 'Key must not be undefined'
		} else if (typeof(key)==='number')  {
			return ''+key
		} else {
			return key
		}
	}
	/**
     * Puts/replaces a value in the map with the specific key
     * @param key
     * @param val
     * @return {Object} if there already was an object associated to the key
     * it will be returned otherwise null
     */
	put(key,val : T) {
		key = this._key(key)
		var existing = null
		if (this.holder[key]!==undefined) {
			existing = this.holder[key]
		}
		this.holder[key] = val

		if (existing==null) {
			this.length++
		}


		return existing
	}
	/**
     * Get a values by its key, null if no values are associated with the specified key
     * @param key - key of the value to return
     * @return {Object}
     */
	get(key)  : T {
		key = this._key(key)
		if (this.holder[key]!==undefined) {
			return this.holder[key]
		} else {
			return null
		}
	}
	/**
     * Removes and returns a values associated to the supplied key,
     * null if there was no value with
     * @param key
     * @return {Object}
     */
	remove(key) : T {
		key = this._key(key)
		if (key!==undefined) {
			if (this.holder[key]!==undefined) {
				var val = this.holder[key]
				delete this.holder[key]
				this.length--
				return val
			}
		}
		return null

	}
	/**
     * Get an array of the values in this map
     * @return {Array}
     */
	values() :  T[]{
		var values = new Array()
		for (var v in this.holder) {
			values.push(this.holder[v])
		}
		return values
	}
	/**
     * Gets the keys of the values as an array
     * @return {Array}
     */
	keys() {
		var keys = new Array()
		for (var v in this.holder) {
			keys.push(v)
		}
		return keys
	}
	/**
     * Gets a key value pair { key : k, value : v } array with the key-value pairs
     * @return {Array}
     */
	keyValuePairs() {
		var valuePairs = new Array()
		for (var k in this.holder) {
			valuePairs.push({key : k, value : this.holder[k]})
		}
		return valuePairs
	}
}